import { createContext } from 'react';

export type ReferralContext = {
  referralCode?: string;
  removeReferralCode: () => void;
};

export const referralContext = createContext<ReferralContext>(null as any);
